import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../api";

// ACTIONS --------------------------------------------------------------------

/**
 * @desc Login.
 */
export const login = createAsyncThunk(
  "login/basic",
  async (token, { rejectWithValue }) => {
    try {
      await API.Login({ token });
      return token;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// SLICE ----------------------------------------------------------------------

/**
 * @desc Auth Slice.
 */
export const authSlice = createSlice({
  name: "auth",
  initialState: {
    pending: false,
    loggedIn: false,
    password: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loggedIn = false;
        state.pending = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.password = action.payload;
        state.loggedIn = true;
        state.pending = false;
      })
      .addCase(login.rejected, (state) => {
        state.loggedIn = false;
        state.pending = false;
      });
  },
});

// SELECTORS ------------------------------------------------------------------

export const getAuthSelector = (state) => state.auth;

export const isLoggedInSelector = (state) => !!state.auth.loggedIn;

export const getPasswordSelector = (state) => state.auth.password;

// REDUCER --------------------------------------------------------------------

export default authSlice.reducer;
